// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1JdIf","label":"CategoryService_label__1OoLz","location":"CategoryService_location__1iXEg"};